/**
 * L2-R5: moved verbatim from @core/composers/tim.
 * That host path is now a re-export shim of this file.
 */
import { withData, WithDataDef } from './base-composer';
import { withCompanyContacts, WithCompanyContactsDef } from './company-contacts';
import { GeoTargetLocation } from './tim-elements/target-location';

export function isMatchingObject(obj1: any, obj2: any) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

/**
 * Composer to add /delete Region/Division
 */
export const withLigGeoLocations = () => {
  function addTargetLocation(division) {
    addDivision.call(this, division, 'target_geography');
  }

  function addCurrentLocation(division) {
    addDivision.call(this, division, 'current_geography');
  }

  function addDivision(division, field) {
    this[field] = this[field] || {};
    this[field].lig_geography = !this[field].lig_geography ? [division] : [...this[field].lig_geography, division];
  }

  function deleteTargetLocation(division) {
    deleteDivision.call(this, division, 'target_geography');
  }

  function deleteCurrentLocation(division) {
    deleteDivision.call(this, division, 'current_geography');
  }

  function deleteDivision(
    { id, global_region_desc, division_desc, market_desc, submarket_desc, district_desc, neighborhood_desc },
    field
  ) {
    const division = {
      id,
      global_region_desc,
      division_desc,
      market_desc,
      submarket_desc,
      district_desc,
      neighborhood_desc,
    };
    this[field].lig_geography.splice(
      this[field].lig_geography.findIndex(element =>
        isMatchingObject(
          {
            id: element.id,
            global_region_desc: element.global_region_desc,
            division_desc: element.division_desc,
            market_desc: element.market_desc,
            submarket_desc: element.submarket_desc,
            district_desc: element.district_desc,
            neighborhood_desc: element.neighborhood_desc,
          },
          division
        )
      ),
      1
    );
  }

  function generateLocationId({
    global_region_desc,
    region_desc,
    division_desc,
    market_desc,
    submarket_desc,
    district_desc,
    neighborhood_desc,
  }) {
    return [
      global_region_desc,
      division_desc ? division_desc : region_desc,
      market_desc,
      submarket_desc,
      district_desc,
      neighborhood_desc,
    ]
      .filter(x => !!x)
      .join('.');
  }

  return {
    addDivision,
    addTargetLocation,
    addCurrentLocation,
    deleteDivision,
    deleteCurrentLocation,
    deleteTargetLocation,
    generateLocationId,
  };
};

/**
 * Class definition for Tim composer
 */
export interface TimDef extends WithDataDef, WithCompanyContactsDef {
  [key: string]: any;
}
/**
 * Tim composer function
 * @param state
 * Supports New Geos structure
 */
export const Tim = (state): TimDef => {
  const extendedState = Object.assign(
    {
      target_geography: GeoTargetLocation(state.target_geography),
      current_geography: GeoTargetLocation(state.current_geography),
    },
    // composers
    withData(),
    withLigGeoLocations(),
    withCompanyContacts()
  );
  return Object.assign({}, state, extendedState);
};
